module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds_m_en.07d52034f55b0615a283ba0041d58bc3.png";